<template>
<el-container>
    <el-header>
      <sticky :className="'sub-navbar'">
        <div class="filter-container">
          <!-- <div class="performanceSwitch">
            公开设置
            <el-switch
              :width="50"
              v-model="isEnter"
              @change="openScore"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </div> -->
          <el-button type="primary" icon="el-icon-s-tools" size="small" @click="setSubject">科目设置</el-button>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="scoreIn">成绩导入</el-button>
          <el-button type="primary" icon="el-icon-upload2" size="small" @click="scoreOut">成绩导出</el-button>
          <!-- <el-button type="primary" icon="el-icon-s-promotion" v-if="alarmtypeTwo===0" size="small" @click="sendExamineFunBefore">发起承训审核</el-button>
          <el-button type="primary" icon="el-icon-s-promotion" v-else disabled size="small">发起承训审核</el-button> -->
          <el-button type="success" icon="el-icon-s-tools" size="small" @click="examineFun">审核验印</el-button>
          <!-- <el-select v-model="listQuery.status" @change="search" size="small" style="margin:0px 10px;width: 120px;" clearable placeholder="验印状态">
            <el-option label="已验" :value="1"></el-option>
            <el-option label="未验" :value="2"></el-option>
          </el-select> -->
          <el-select v-model="listQuery.state" @change="search" size="small" style="margin:0px 10px;width: 120px;" clearable placeholder="培训结果">
            <el-option label="合格" value="合格"></el-option>
            <el-option label="不合格" value="不合格"></el-option>
          </el-select>
          <el-input style="margin-right:10px;width:200px;" size="small" placeholder="请输入人员名称" v-model="listQuery.userName" clearable></el-input>
          <el-button type="primary" size="small" icon="el-icon-search" @click="search">搜索</el-button>
          
        </div>
      </sticky>
    </el-header>
    <el-main>
      <div class="peopleScoreListBox">
      <el-table
        stripe
        ref="mainTable"
        :data="list"
        v-loading="listLoading"
        border
        fit
        height="580"
        highlight-current-row
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="46" align="center"></el-table-column>
        <el-table-column width="100px" :label="'姓名'" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="cursor: pointer;" class="title1">{{scope.row.name}}</span>
          </template>
        </el-table-column>

        <el-table-column width="60px" :label="'性别'" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sex==true">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>

        <el-table-column width="50px" :label="'年龄'" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.age}}</span>
          </template>
        </el-table-column>
        <el-table-column width="70px" align="center" show-overflow-tooltip :label="'民族'">
          <template slot-scope="scope">
            <span>{{scope.row.ethic}}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110px" show-overflow-tooltip :label="'工作单位'">
          <template slot-scope="scope">
            <span>{{scope.row.unit}}</span>
          </template>
        </el-table-column>

        <el-table-column width="110px" show-overflow-tooltip align="center" :label="'职务/职级'">
          <template slot-scope="scope">
            <span>{{scope.row.zwmc}}</span>
          </template>
        </el-table-column>

        <el-table-column width="110px" show-overflow-tooltip align="center" :label="'电话'">
          <template slot-scope="scope">
            <span>{{scope.row.phone}}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          :label="item"
          :prop="item"
          v-for="(item,index) in getColumnName"
          :key="index"
        ></el-table-column>

        <!-- <el-table-column :label="'综合分数'" min-width="100">
          <template slot-scope="scope">
            <span>{{scope.row.score}}</span>
          </template>
        </el-table-column>-->
        <el-table-column width="90px" show-overflow-tooltip align="center" label="验印状态">
          <template slot-scope="scope">
            <span style="color: green;" v-if="scope.row.yz_status === 1">已验</span>
            <span style="color: red;" v-else-if="scope.row.yz_status === 0">未验</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="'培训结果'" width="80">
          <template slot-scope="scope">
            <span>{{scope.row.state}}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" width="160" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click.prevent="beforeSetRowFun(scope.row)" size="mini" plain>修改</el-button>
            <el-button type="primary" @click.prevent="openTrianInfo(scope.row)" size="mini" plain>档案</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        style="margin-top: 10px;"
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="handleCurrentChange"
      />
      </div>
    </el-main>

    <!-- 成绩导入 -->
    <el-dialog
      title="提示"
      :visible.sync="batchDialogVisible"
      destroy-on-close
      width="576px"
      append-to-body
      center
      :before-close="batchHandleClose"
    >
      <div>
        <el-form ref="formRef" label-width="100px">
          <el-form-item label="模板下载:">
            <el-button
              size="small"
              type="text"
              @click="download"
              style="text-decoration:underline;"
            >模板例子</el-button>
          </el-form-item>
          <el-form-item label="文件导入:">
            <el-upload
              :headers="headers"
              :on-change="onChange"
              class="upload-demo"
              drag
              :auto-upload="false"
              :action="url"
              accept=".xls, .xlsx"
              ref="fileTemplete"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击导入</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能导入.xls, .xlsx文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: right;">
          <el-button @click="batchDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="upFile">确 定 导 入</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 科目设置 -->
    <el-dialog
      title="科目设置"
      :visible.sync="setSubjectDialog"
      destroy-on-close
      append-to-body
      v-el-drag-dialog
      class="dialog-mini"
      width="400px"
    >
      <!-- <el-form ref="formRef" label-width="100px">
        <el-form-item label>
          <el-button @click="addSubject" type="primary">添加</el-button>
          <el-button @click="addZDSubject" type="primary">添加字典科目</el-button>
        </el-form-item>
        <el-form-item label="科目:" v-for="( item,index) in subjectList" :key="index">
          <el-select v-model="subjectList[index].dicid" clearable placeholder="请选择">
            <el-option
              v-for="(item,indexs) in options"
              :key="indexs"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>-->
      <div style="margin-bottom:10px;">
        <el-button @click="addSubject" type="primary">添加科目</el-button>
        <!-- <el-button @click="addZDSubject" type="primary">添加字典科目</el-button> -->
      </div>
      <div class="scoreManageTable">
        <el-table :data="subjectList" ref="mainTable" stripe>
          <el-table-column label="科目" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.dicid"
                clearable
                placeholder="请选择"
                @change="selectdicid(scope.$index)"
              >
                <el-option
                  v-for="(item,indexs) in options"
                  :key="indexs"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="danger" plain @click="deleteSubject(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setSubjectDialog = false">取 消</el-button>
        <el-button type="primary" @click="addSuject">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="添加字典科目"
      :visible.sync="addZDSubjectDialog"
      destroy-on-close
      append-to-body
      v-el-drag-dialog
      class="dialog-mini"
      width="400px"
    >
      <el-form
        :rules="rules"
        ref="dataForm"
        :model="temp"
        label-position="right"
        label-width="100px"
      >
        <el-form-item size="small" :label="'名称'" prop="name">
          <el-input v-model="temp.name"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'排序号'" prop="sort">
          <el-input-number v-model="temp.sort" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item prop="code" label="编号">
          <el-input size="small" v-model="temp.code"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'描述'" prop="descrip">
          <el-input v-model="temp.descrip"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addZDSubjectDialog = false">取 消</el-button>
        <el-button type="primary" @click="createData">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改成绩 -->
    <el-dialog
      title="修改成绩"
      :visible.sync="setScoreDlog"
      append-to-body
      destroy-on-close
      v-el-drag-dialog
      class="dialog-mini"
      width="400px"
    >
      <div>
        <el-form :model="scoreFrom" ref="scoreFromDom" label-width="100px">
          <el-form-item label="姓名：">
            <span>{{scoreFrom.name}}</span>
          </el-form-item>
          <el-form-item label="性别：">
            <span v-if="scoreFrom.sex==true">男</span>
            <span v-else>女</span>
          </el-form-item>
          <el-form-item label="工作单位：">
            <span>{{scoreFrom.unit}}</span>
          </el-form-item>
          <el-form-item label="电话：">
            <span>{{scoreFrom.phone}}</span>
          </el-form-item>
          <el-form-item v-for="(item,index) in newColmnList" :key="index" :label="item + '：'">
            <el-input v-model="scoreFrom[item]" clearable></el-input>
          </el-form-item>
          <el-form-item label="培训结果：">
            <el-select v-model="scoreFrom.state" clearable placeholder=" ">
              <el-option label="合格" value="合格"></el-option>
              <el-option label="不合格" value="不合格"></el-option>
              <!-- <el-option label="缓考" value="缓考"></el-option>
              <el-option label="免考" value="免考"></el-option> -->
              <!-- <el-option label="退训" value="退训"></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setScoreDlog = false">取 消</el-button>
        <el-button type="primary" @click="setRowInfo">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 审核 -->
    <el-dialog
      title="审核验印"
      :visible.sync="passDialogShow"
      width="30%"
      destroy-on-close
      append-to-body
      v-el-drag-dialog
      class="dialog-mini"
    >
      <el-form ref="tempRef" :model="passObj" :rules="passRules" label-width="80px">
        <el-form-item label="">
          <el-radio-group @change="passSelChange" v-model="passObj.isPass">
            <el-radio :label="true">合格</el-radio>
            <el-radio :label="false">不合格</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见" prop="idea">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入意见"
            v-model="passObj.idea"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="submitExamineFun">提 交</el-button>
      </span>
    </el-dialog>
</el-container>
</template>

<script>
import Sticky from '@/components/Sticky';
import Pagination from '@/components/Pagination';
import * as apiTrainPeople from '@/api/train/trainPeople';
import * as apiTrainInfo from '@/api/train/trainInfo';
import { getUserScoreList, getColumnName } from '@/api/train/index.js';
import elDragDialog from '@/directive/el-dragDialog';
import * as pmiDictionarys from '@/api/pmi/dictionarys'; //接口
import axios from 'axios';
import eleSelect from '@/components/elSelect'; //下拉框

export default {
  props: ['trainId', 'issorece', 'trainTitle','alarmtype'],
  components: {
    Sticky,
    Pagination,
    eleSelect,
  },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      sid: +new Date(),
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        status: 2,
        state: null,
        userName: '',
        trainId: null,
        page: 1,
        limit: 10,
      },
      batchDialogVisible: false,
      fileData: '',
      url: '/api/TrainPeople/ImportScore?',
      setSubjectDialog: false,
      addZDSubjectDialog: false,
      temp: {
        name: '', //名称
        descrip: '', //描述
        sort: 0, //排序
        namespaceId: 68, //空间id
        code: null,
        userId: this.$store.state.User.ids,
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
      subjectList: [
        {
          dicid: null,
        },
      ],
      subjectObj: {
        trainId: null,
        dicid: null,
        createId: parseInt(this.$store.state.User.ids),
      },
      options: [],
      isEnter: 0,
      getColumnName: [],
      dicidfalg: false,
      setScoreDlog: false,
      scoreFrom: {},
      newColmnList: [],
      selList:[],
      passObj:{
        isPass: true,
        idea: '培训合格，予以结业！',
        type: this.alarmtype,
        trainId: this.trainId,
      },
      passDialogShow: false,
      passRules:{
        idea: [
          { required: true, message: '请输入意见', trigger: 'blur' },
        ],
      },
      alarmtypeTwo: this.alarmtype,
    };
  },
  created() {
    this.subjectObj.trainId = this.trainId;
    this.isEnter = this.issorece;
    this.getOptions();
    this.getList();
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.token,
      };
    },
  },
  methods: {
    passSelChange(val){
      if(val){
        this.passObj.idea = '培训合格，予以结业！';
      }else{
        this.passObj.idea = '培训不合格，择期复训。';
      }
    },
    //打开审核
    examineFun(){
      if(this.selList.length == 0){
        this.$message.warning('请至少勾选一个');
        return false
      }
      this.passDialogShow = true;
    },
    //提交审核结果
    submitExamineFun(){
      this.$refs['tempRef'].validate((valid) => {
        if(valid){
          let ids = this.selList.map(item=>item.id);
          pmiDictionarys.examineScoreApi(ids,this.passObj).then(res=>{
            if(res.code == 200){
              this.$message.success('提交成功');
              this.passDialogShow = false;
              this.getList();
            }
          })
        }
      });
    },
    //发起审核申请前
    sendExamineFunBefore(){
      if(this.alarmtypeTwo === 5){
        this.$confirm('您已发起过承训审核申请，是否重新发起?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendExamineFun();
          this.alarmtypeTwo = 1;
        })
      }else{
        this.sendExamineFun();
      }
    },
    //发起审核
    sendExamineFun(){
      let info = {};
      if(typeof this.$store.state.User.infos === 'string'){
        info = JSON.parse(this.$store.state.User.infos);
      }else{
        info = this.$store.state.User.infos;
      }
      let para = {
        userId: info.id,
        userName: info.name,
        trainId: this.trainId,
        type: this.alarmtype
      }
      pmiDictionarys.sendExamineApi(para).then(res=>{
        if(res.code == 200){
          this.$message.success('操作成功');
        }
      })
    },
    //勾选人员
    handleSelectionChange(val){
      this.selList = val;
    },
    //选择科目
    selectdicid(index) {
      const dicidList = this.subjectList.map((value) => value.dicid);
      const dicid = new Set(dicidList);
      if (dicid.size != dicidList.length) {
        this.subjectList[index].dicid = '';
        this.$message({
          message: '不可以添加相同的科目!',
          type: 'warning',
        });
        return false;
      }
    },
    //删除科目
    deleteSubject(row, index) {
      this.subjectList.splice(index, 1);
    },
    //获取字典科目数组
    getOptions() {
      pmiDictionarys.PmiDictionaryGetByTypeId({ NamespaceId: 68 }).then((res) => {
        this.options = res.result;
      });
    },
    //确认添加科目
    addSuject() {
      if (this.subjectList.length != 0) {
        this.subjectList.forEach((item) => {
          if (!item.dicid) {
            return (this.dicidfalg = false);
          } else {
            this.dicidfalg = true;
          }
        });
      } else {
        this.dicidfalg = true;
      }
      if (this.dicidfalg) {
        apiTrainInfo
          .addSubject({ trainId: this.trainId }, this.subjectList)
          .then((res) => {
            this.$message.success('成功！');
            this.setSubjectDialog = false;
            this.getList();
          });
      } else {
        this.$message.warning('科目不能为空！');
      }
    },
    //警种类别
    AddjzDic(item, row) {
      // this.subjectObj.dicid = row.value;
      // this.subjectObj.jzDicName = row.label;
      this.getList();
    },
    //添加
    addSubject() {
      this.subjectObj = {
        trainId: this.trainId,
        dicid: null,
        createId: parseInt(this.$store.state.User.ids),
      };
      this.subjectList.push(this.subjectObj);
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          pmiDictionarys.add(this.temp).then((response) => {
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000,
            });
            this.getOptions();
            this.addZDSubjectDialog = false;
          });
        }
      });
    },
    //添加字典科目
    addZDSubject() {
      this.temp = {
        name: '', //名称
        descrip: '', //描述
        sort: 0, //排序
        namespaceId: 68, //空间id
        code: null,
        userId: this.$store.state.User.ids,
      };
      this.addZDSubjectDialog = true;
    },
    //点击科目设置
    setSubject() {
      this.setSubjectDialog = true;
      apiTrainInfo.getSubject({ trainId: this.trainId }).then((res) => {
        this.subjectList = res.result;
      });
    },
    openScore() {
      let para = {
        trainId: this.trainId,
        status: this.isEnter,
      };
      apiTrainInfo.publicScore(para).then((res) => {
        if (res.code == 200) {
          this.$message.success('设置成功！');
        }
      });
    },
    //文件选择时
    onChange(file, fileList) {
      this.fileData = file; // 保存当前选择文件
      URL.createObjectURL(file.raw);
    },
    // 文件下载
    download() {
      let url = `/api/TrainPeople/DownModel?trainId=${this.trainId}`;
      let data = {};
      axios({
        method: 'get', // 设置请求方式（一般为get）
        url: url, // 请求链接（这里为获取数据的链接，得到数据）
        responseType: 'blob',
        data,
        headers: { Authorization: 'Bearer ' + this.$store.getters.token }, // 传token
      }).then((res) => {
        let result = res.data;
        let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
        let src = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.download =this.trainTitle+'成绩导入.xls';
        link.href = src;
        link.click();
      });
    },
    //确认上传excel
    upFile() {
      let _this = this;
      if (_this.$refs.fileTemplete.uploadFiles.length > 0) {
        let formData = new FormData();
        formData.append(
          'publicFile',
          _this.$refs.fileTemplete.uploadFiles[0].raw
        );
        formData.append(
          'fileName',
          _this.$refs.fileTemplete.uploadFiles[0].name
        );
        _this.url = '/api/TrainPeople/ImportScore?';
        _this.url = `${_this.url}trainId=${_this.trainId}`;
        apiTrainPeople.importScore(_this.url, formData).then((res) => {
          if (res.code !== 200) {
            this.$message.error('上传失败！');
          } else {
            _this.$message.success('上传成功');
            _this.getList();
            this.$refs.fileTemplete.clearFiles();
            _this.batchDialogVisible = false;
          }
        });
      }
    },
    batchHandleClose() {
      this.batchDialogVisible = false;
    },
    //搜索
    search(){
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listQuery.trainId = this.trainId;
      this.listQuery.status = this.listQuery.status ? this.listQuery.status : null;
      getUserScoreList(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.count;
        this.listLoading = false;
      });
      getColumnName({ trainId: this.trainId }).then((res) => {
        this.getColumnName = res.result;
      });
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getList();
    },
    scoreIn() {
      this.batchDialogVisible = true;
    },
    scoreOut(){
      let url = `/api/TrainPeople/ExportScore?trainId=${this.trainId}`;
      let data = {};
      axios({
        method: 'get', // 设置请求方式（一般为get）
        url: url, // 请求链接（这里为获取数据的链接，得到数据）
        responseType: 'blob',
        data,
        headers: { Authorization: 'Bearer ' + this.$store.getters.token }, // 传token
      }).then((res) => {
        let result = res.data;
        let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
        let src = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.download = this.trainTitle + '成绩导出.xls';
        link.href = src;
        link.click();
      });
    },
    //修改成绩前
    beforeSetRowFun(row){
      let names = this.options.map(item=>item.name);
      this.newColmnList = this.getColumnName.filter(item=>names.includes(item));
      this.scoreFrom = JSON.parse(JSON.stringify(row));
      this.setScoreDlog = true;
    },
    //打开训历档案
    openTrianInfo(row){
      window.open('/userArchives?trainId='+this.trainId + '&userId=' + row.userid);
    },
    //保存修改成绩
    setRowInfo(){
      let listArr = [];
      this.newColmnList.map(item=>{
        const val = this.scoreFrom[item] ? this.scoreFrom[item] : '';
        let str = item + ':' + val;
        listArr.push(str)
      });
      listArr.push('培训结果:' + this.scoreFrom.state);
      const listStr = listArr.join(',');
      let para = {
        userId: this.scoreFrom.userid,
        trainId: this.trainId,
        val: listStr,
      };
      apiTrainPeople.updateScore(para).then(res=>{
        if(res.code == 200){
          this.$message.success(res.message);
          this.getList();
          this.setScoreDlog = false;
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.performanceSwitch {
  display: inline-block;
  align-items: center;
  margin: 0 20px;
  height: 30px;
  line-height: 30px;
}
</style>

<style scoped>
/deep/.scoreManageTable .el-table th{
  background-color: #f3f4f793 !important;
}
/deep/.peopleScoreListBox .el-table .el-table__body-wrapper{
  height: 530px !important;
}
</style>